import { formatDisplayMonth, formatDisplayDateTime } from "../../../Helper/functionHelper.js";
const money = (v) => (v === null || v === undefined ? "N/A" : `₹${Number(v).toFixed(2)}`);

const getColumns = (handleView) => [
  {
    label: "Employee",
    field: "employee_name",
    className: "fw-semibold",
    sortable: true,
    render: (row) => row.employee_name || "N/A",
  },
  {
    label: "Employee ID",
    field: "employee_code",
    sortable: true,
  },
  {
    label: "Month",
    field: "month_year",
    sortable: true,
    render: (row) => formatDisplayMonth(row.month_year),
  },
  {
    label: "Days Worked",
    field: "days_worked",
    className: "text-end",
    sortable: true,
    render: (row) => `${row.days_worked} / ${row.total_days}`,
  },
  {
    label: "Node Gross",
    field: "gross",
    className: "text-end",
    sortable: true,
    render: (row) => money(row.gross),
  },
  {
    label: "Node Net Pay",
    field: "net_pay",
    className: "fw-semibold text-end",
    sortable: true,
    render: (row) => money(row.net_pay),
  },
  {
    label: "Last Run",
    field: "updated_at",
    sortable: true,
    render: (row) => formatDisplayDateTime(row.updated_at || row.created_at),
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleView(row)} title="View diff vs CI4">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            visibility
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;
